import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Mail } from "lucide-react";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-1">
            <Link to="/">
              <img
                src="/lovable-uploads/be1f07ad-0b0f-42a6-a096-054559dbb5f4.png"
                alt="Frikopplad Logotyp"
                className="h-8 w-auto mb-4"
              />
            </Link>
            <p className="text-gray-600 mb-4">{t("footer.helpingEuropeans")}</p>
            <div className="flex space-x-4">
              <a
                href="mailto:jtensetti@protonmail.com"
                aria-label={t("footer.contact")}
                className="text-frikopplad-navy hover:text-frikopplad-red transition-colors"
              >
                <Mail className="h-5 w-5" aria-hidden="true" />
              </a>
              <a
                href="https://codeberg.org/Tensetti/Frikopplad.nu/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Codeberg"
                className="text-frikopplad-navy hover:text-frikopplad-red transition-colors group"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="inline-block h-5 w-auto">
                  <path
                    fill="#669bbc"
                    className="group-hover:fill-frikopplad-red transition-colors"
                    d="M12 1A11 11 0 0 0 1 12a11 11 0 0 0 1.7 6.4L12 6l9.3 12.4A11 11 0 0 0 23 12 11 11 0 0 0 12 1Z"
                  />
                  <path
                    fill="#003049"
                    className="group-hover:fill-frikopplad-red transition-colors"
                    d="M21.3 18.4 12 6l4.4 16.8a11 11 0 0 0 4.9-4.4Z"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg text-frikopplad-navy mb-4">{t("footer.navigate")}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  {t("navbar.home")}
                </Link>
              </li>
              <li>
                <Link to="/varfor" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  {t("navbar.whySwitch")}
                </Link>
              </li>
              <li>
                <Link to="/alternativ" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  {t("navbar.alternatives")}
                </Link>
              </li>
              <li>
                <Link to="/om" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  {t("navbar.about")}
                </Link>
              </li>
              <li>
                <Link to="/paket" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  {t("navbar.getStarted")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg text-frikopplad-navy mb-4">{t("footer.resources")}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/fragor" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  {t("navbar.faq")}
                </Link>
              </li>
              <li>
                <Link to="/ordlista" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  {t("navbar.glossary")}
                </Link>
              </li>
              <li>
                <Link to="/resurser" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  {t("navbar.resources")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg text-frikopplad-navy mb-4">{t("footer.information")}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/juridik" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  {t("footer.legal")}
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  {t("footer.cookiePolicy")}
                </Link>
              </li>
              <li>
                <Link to="/press" className="text-gray-600 hover:text-frikopplad-red transition-colors">
                  Press
                </Link>
              </li>
              <li>
                <a
                  href="mailto:jtensetti@protonmail.com"
                  className="text-gray-600 hover:text-frikopplad-red transition-colors"
                >
                  {t("footer.contact")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 mt-12 pt-8 flex flex-col md:flex-row md:justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Frikopplad. {t("footer.allRightsReserved")}
          </p>
          <p className="text-gray-500 text-sm">
            {t("footer.initiative")}{" "}
            <Link to="/om" className="text-frikopplad-navy hover:text-frikopplad-red">
              Jonatan Tensetti
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
